var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.8 19.714V9.43q0-.543.239-1.029.24-.486.66-.8l6.75-5.143A2.15 2.15 0 0 1 12.8 2q.76 0 1.35.457L20.9 7.6q.422.315.662.8t.239 1.029v10.285q0 .943-.661 1.615a2.15 2.15 0 0 1-1.59.671h-3.374a1.08 1.08 0 0 1-.802-.329 1.12 1.12 0 0 1-.323-.814v-5.714q0-.486-.324-.814a1.08 1.08 0 0 0-.801-.329h-2.25q-.478 0-.802.329-.323.328-.323.814v5.714q0 .486-.324.814a1.08 1.08 0 0 1-.801.329H6.05a2.15 2.15 0 0 1-1.59-.671 2.22 2.22 0 0 1-.66-1.615"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFill);
export default __webpack_public_path__ + "static/media/home_fill.bc9cb45ceb99903b54284acb3694a9fb.svg";
export { ForwardRef as ReactComponent };